import { z } from "zod";

export const emailUnsubscribeSchema = z.object({
  email: z.string().email("Veuillez entrer une adresse email valide"),
  reason: z.string().optional(),
});

export type EmailUnsubscribeForm = z.infer<typeof emailUnsubscribeSchema>;

export const defaultEmailUnsubscribeValues: EmailUnsubscribeForm = {
  email: "",
  reason: "",
};
